export const LIST_TYPES = ["ordered-list-item", "unordered-list-item"];

export const TEXT_ALIGN_TYPES = ["left", "center", "right", "justify"];

export const TABLE_TYPES = ["table", "table-row", "table-cell"];
